import * as React from 'react';
import { TDirection } from '@cian/frontend-newbuilding-carousel-component';
import { RoundButton } from '@cian/ui-kit/button';
import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './Arrow.css';

interface IArrowProps {
  direction: TDirection;
  clickHandler?(direction: TDirection): void;
}

export const Arrow: React.FC<IArrowProps> = props => {
  const { direction, clickHandler } = props;
  const isPrevious = direction === -1;
  const Icon = isPrevious ? IconActionChevronLeft16 : IconActionChevronRight16;

  return (
    <div className={styles['click-area']}>
      <RoundButton
        theme="dark"
        size="M"
        icon={<Icon color="icon-inverted-default" />}
        onClick={() => clickHandler && clickHandler(direction)}
        data-testid={`Arrow-${isPrevious ? 'Previous' : 'Next'}`}
        title={isPrevious ? 'Предыдущий слайд' : 'Следующий слайд'}
      />
    </div>
  );
};
